'use client';

import { useCallback, useEffect, useState } from 'react';

export function useFooterInView(offset = 0): boolean {
  const [footerInView, setFooterInView] = useState(false);

  const check = useCallback(() => {
    const footer = document.querySelector('footer');
    if (!footer) return;
    const { top, bottom } = footer.getBoundingClientRect();
    setFooterInView(top < window.innerHeight - offset && bottom > 0);
  }, [offset]);

  useEffect(() => {
    check();
    window.addEventListener('scroll', check, { passive: true });
    document.addEventListener('scroll', check, {
      passive: true,
      capture: true,
    });
    window.addEventListener('resize', check, { passive: true });
    return () => {
      window.removeEventListener('scroll', check);
      document.removeEventListener('scroll', check, { capture: true });
      window.removeEventListener('resize', check);
    };
  }, [check]);

  return footerInView;
}
